export const SET_NOTIFICATION_TYPES = 'setNotificationTypes';
export const SET_FCM_DEVICES = 'setFcmDevices';
